<template>
  <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
    <el-form ref="form" label-position="left" :model="form" label-width="120px">
      <el-form-item label="所属仓库" required>
        <el-select v-model="form.warehouse" placeholder="请选择所属仓库" style="width: 100%" :disabled="true">
          <el-option :label="item.wareName" :value="item.wareCode" v-for="item in warehouse" :key="item.wareCode">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="库区名称" required>
        <el-input maxlength='450' v-model="form.regionName" placeholder="请输入库区名称"></el-input>
      </el-form-item>
      <el-form-item label="商品状态">
        <el-select v-model="form.bindStatus" placeholder="请指定商品状态" style="width: 100%">
          <el-option :label="item.desc" :value="item.val" v-for="item in statusList" :key="item.val"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="库区负责人" required>
        <el-input maxlength='450' v-model="form.regionContact" placeholder="请输入库区负责人"></el-input>
      </el-form-item>
      <el-form-item label="负责人电话" required>
        <el-input maxlength='450' v-model="form.contactPhone" placeholder="请输入库区负责人电话"></el-input>
      </el-form-item>
      <el-form-item label="库区地址">
        <el-input maxlength='450' v-model="form.province" style="margin-bottom: 10px">
          <template slot="prepend">省</template>
        </el-input>
        <el-input maxlength='450' v-model="form.city" style="margin-bottom: 10px">
          <template slot="prepend">市</template>
        </el-input>
        <el-input maxlength='450' v-model="form.area" style="margin-bottom: 10px">
          <template slot="prepend">区</template>
        </el-input>
      </el-form-item>
      <el-form-item label="库区详细地址">
        <el-input maxlength='450' v-model="form.address"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">立即创建</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { Validator } from "@/utils/verification";
export default {
  name: "SetArea",
  data() {
    return {
      dialogVisible: false,
      form: {
        warehouse: this.$store.getters.getWareCode,
        regionName: "",
        bindStatus: "",
        regionContact: "",
        contactPhone: "",
        province: "",
        city: "",
        area: "",
        address: "",
      },
      statusList: [
        { desc: "初检", val: 0 },
        { desc: "复检", val: 1 },
        { desc: "质检", val: 3 },
        { desc: "成品", val: 4 },
        { desc: "异常", val: 5 },
        { desc: "次品", val: 6 },
      ],
    };
  },
  props: {
    warehouse: {
      type: Array,
      required: true,
    },
  },
  watch: {
    dialogVisible: function (newval) {
      if (!newval) {
        this.form = {
          warehouse: this.$store.getters.getWareCode,
          regionName: "",
          bindStatus: "",
          name: "",
          tell: "",
          province: "",
          city: "",
          area: "",
          address: "",
        };
      }
    },
  },
  methods: {
    open: function (r) {
      if (r) {
        this.form = JSON.parse(JSON.stringify(r));
        if (this.form.regionAddress) {
          let regionAddress = this.form.regionAddress
          this.form.province = regionAddress&&regionAddress.split('省')[0]
          let regionCity = regionAddress&&regionAddress.split('省')[1]
          this.form.city = regionCity&&regionCity.split('市')[0]
          let regionArea = regionCity&&regionCity.split('市')[1]
          this.form.area = regionCity&&regionArea.split('区')[0]
          this.form.address = regionCity&&regionArea.split('区')[1]
        }
      }
      this.dialogVisible = true;
    },
    close: function () {
      this.dialogVisible = false;
    },
    onSubmit: function () {
      let validator = new Validator();
      validator.add(this.form.warehouse, "isNoneEmpty", "请选择所属仓库");
      validator.add(this.form.regionName, "isNoneEmpty", "请输入库区名称");
      // validator.add(this.form.bindStatus, "isNoneEmpty", "请指定商品状态");
      validator.add(this.form.regionContact, "isNoneEmpty", "请输入库区负责人");
      validator.add_batch(
        this.form.contactPhone, [{ strategy: 'isNoneEmpty', errorMsg: '请输入库区负责人电话' }, { strategy: 'isMobile', errorMsg: '号码格式错误' }]
      );
      let error = validator.start();
      if (error) {
        this.$message.error(error);
        return;
      }
      this.dialogVisible = false;
      let params = JSON.parse(JSON.stringify(this.form))
      params.regionAddress = params.province + '省' + params.city + '市' + params.area + '区' + params.address
      delete params.province
      delete params.city
      delete params.area
      delete params.address
      if (this.form.id) {
        this.$emit("onSubmit", params);
        return;
      }
      this.$emit("add", params);
    },
  },
};
</script>

<style scoped>
</style>
